import React, { useState } from 'react'

const Graphs = () => {
    return  <div>
            </div>
}

export default Graphs
